import { render, staticRenderFns } from "./sidebarTwo.vue?vue&type=template&id=2532efcc&"
import script from "./sidebarTwo.vue?vue&type=script&lang=js&"
export * from "./sidebarTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports